import ImageModalCardBodyView from './ImageModalCardBodyView';



export default ImageModalCardBodyView;
